import store from '@/base/store'
import { PaymentFee } from './paymentFee.class'

export class PaymentAmount {
  static get paywallPaymentData () {
    return store.state.payment.paymentData
  }

  /**
   * Returns the total transaction amount including commission where applicable.
   * Used for all external SDK initialisations (GooglePay, ApplePay, VisaCheckout,
   * Click2Pay, card widget) and for analytics events.
   *
   * - Fee inactive → clean base amount (transaction.payAmount)
   * - Legacy mode (root-level customerFee) → payAmount already includes the fee, returned as-is
   * - New individual-fee mode (per-payway fees, no root customerFee) → base + active-payway fee
   */
  static getTransactionAmount () {
    const baseAmount = Number(PaymentAmount.paywallPaymentData?.transaction?.payAmount) || 0
    if (!PaymentFee.isPaymentFeeActive() || PaymentFee.isPaymentFeeLegacyMode()) {
      return baseAmount
    }
    return baseAmount + PaymentFee.getPaymentFeeForActivePaywayAsNumber()
  }
}
